/* eslint-disable @typescript-eslint/explicit-function-return-type */
import {Vue, Component} from 'vue-property-decorator';
import {centerWinOptions} from '@/utils/commonUtils';
import claimStatusTypes from '@/const/words/claimStatusTypes_multilang';
import {ClaimType, RefundType} from '@/types/claim';
import {ClaimStatusType, GridNameType} from 'supporter';


interface OptionForOpeningWindow {
  url: string,
  label: string,
  widthOfWindow: number,
  heightOfWindow: number,
}


@Component
export default class ClaimColumns extends Vue {
  private columnFormat = {
    claimYmdt: {
      header: '',
      name: 'claimYmdt',
      minWidth: 131,
      align: 'center',
      formatter: (data: any) => {
        return data.value ? data.value : '-';
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    claimCompleteYmdt: {
      header: '',
      name: 'claimCompleteYmdt',
      minWidth: 131,
      align: 'center',
      formatter: (data: any) => {
        return data.value ? data.value : '-';
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    procEachBtn: {
      header: 'CLAIM_COLUMNS_CLAIM_PROC',
      name: 'procEachBtn',
      minWidth: 141,
      align: 'center'
    },
    claimCnt: {
      header: '',
      name: 'claimCnt',
      minWidth: 61,
      align: 'left',
      formatter: (data: any): any => {
        if (data.value > 1) {
          return `<span class="highlight">${data.value}</span>`;
        }

        return data.value;
      },
      copyOptions: {
        useFormattedValue: true,
        customValue: (data: any): any => {
          return data;
        }
      }
    }
  };

  private claimListColumns = {
    취소신청일시: {
      ...this.columnFormat.claimYmdt,
      header: 'CLAIM_COLUMNS_CANCEL_YMDT'
    },
    취소완료일시: {
      ...this.columnFormat.claimCompleteYmdt,
      header: 'CLAIM_COLUMNS_CANCEL_COMPLETE_YMDT'
    },
    교환신청일시: {
      ...this.columnFormat.claimYmdt,
      header: 'CLAIM_COLUMNS_EXCHANGE_YMDT'
    },
    교환완료일시: {
      ...this.columnFormat.claimCompleteYmdt,
      header: 'CLAIM_COLUMNS_EXCHANGE_COMPLETE_YMDT'
    },
    반품신청일시: {
      ...this.columnFormat.claimYmdt,
      header: 'CLAIM_COLUMNS_RETURN_YMDT'
    },
    반품완료일시: {
      ...this.columnFormat.claimCompleteYmdt,
      header: 'CLAIM_COLUMNS_RETURN_COMPLETE_YMDT'
    },
    환불신청일시: {
      ...this.columnFormat.claimYmdt,
      header: 'CLAIM_COLUMNS_REFUND_YMDT'
    },
    환불완료일시: {
      ...this.columnFormat.claimCompleteYmdt,
      header: 'CLAIM_COLUMNS_REFUND_COMPLETE_YMDT',
      name: 'completeYmdt'
    },
    반품수거방법: {
      header: 'CLAIM_COLUMNS_RETURN_WAY_TYPE',
      name: 'returnWayType',
      minWidth: 131,
      align: 'center',
      formatter: (row: any) => {
        return row.value ? window.$t(`ORDER_ORDER_CONTENT_TOP_RETURN_WAY_TYPE_${row.value}`) : '-';
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    취소클레임처리: {
      ...this.columnFormat.procEachBtn,
      formatter: ({row}) => {
        const { claimStatusType, claimNo, orderOptionNo } = row;

        return this.claimManagementBtnMaker(claimStatusType, claimNo, orderOptionNo);
      }
    },
    교환클레임처리: {
      ...this.columnFormat.procEachBtn,
      formatter: ({ row }) => {
        const { claimStatusType, claimNo, orderOptionNo } = row;

        return this.claimManagementBtnMaker(claimStatusType, claimNo, orderOptionNo);
      }
    },
    반품클레임처리: {
      ...this.columnFormat.procEachBtn,
      formatter: ({row}) => {
        const { claimStatusType, claimNo, orderOptionNo } = row;

        return this.claimManagementBtnMaker(claimStatusType, claimNo, orderOptionNo);
      }
    },
    송장번호: {
      header: 'CLAIM_COMMON_INVOICE_NO',
      name: 'invoiceNo',
      minWidth: 101,
      align: 'center',
      formatter: (data: any) => {
        return data.value ? data.value : '-';
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    반품송장번호: {
      header: 'CLAIM_COMMON_RETURN_INVOICE_NO',
      name: 'returnInvoiceNo',
      minWidth: 101,
      align: 'center',
      formatter: (data: any) => {
        return data.value ? data.value : '-';
      }
    },
    클레임상태: {
      header: 'CLAIM_COLUMNS_CLAIM_STATUS_TYPE',
      name: 'claimStatusType',
      minWidth: 136,
      align: 'center',
      formatter: (data: any) => {
        if (!data.value) {
          return '';
        }

        const claimStatusTypeName = claimStatusTypes.find(claimStatusType => claimStatusType.value === data.value)?.name;
        return claimStatusTypeName ? window.$t(claimStatusTypeName) : '';
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    클레임번호: {
      header: 'CLAIM_COLUMNS_CLAIM_NO',
      name: 'claimNo',
      minWidth: 101,
      align: 'center',
      formatter: (data: any) => {
        return `<a onMouseOver="this.style.cursor='pointer'" onclick="window.open('/claim/viewPopup?orderProductOptionNo=${data.row.orderOptionNo}&isResult=true&claimNo=${
          data.value
        }&callback=reSearchClaim', '${window.$t('CLAIM_COLUMNS_SHOW_ORDER_DETAIL')}', '${centerWinOptions(1024, 1000)}');">${data.value}</a>`;
      }
    },
    쇼핑몰구분: {
      header: 'CLAIM_COLUMNS_MALL_NAME',
      name: 'mallName',
      minWidth: 101,
      align: 'center'
    },
    주문구분: {
      header: 'CLAIM_COLUMNS_ORDER_REGISTER_TYPE',
      name: 'orderRegisterType',
      minWidth: 61,
      align: 'center',
      formatter: row => {
        return window.$t(`CLAIM_COLUMNS_ORDER_REGISTER_TYPE_${row.value}`);
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    예약주문: {
      header: 'CLAIM_COLUMNS_RESERVED',
      name: 'reserved',
      minWidth: 61,
      align: 'center',
      formatter: (row: any) => {
        return row.value ? 'Y' : '-';
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    결제수단: {
      header: 'CLAIM_COLUMNS_PAYTYPE',
      name: 'payType',
      minWidth: 81,
      align: 'center',
      formatter: data => {
        return data.row.payTypeLabel
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    배송보류: {
      header: 'CLAIM_COLUMNS_HOLD_PROCESS',
      name: 'holdProcess',
      minWidth: 61,
      align: 'center',
      formatter: (data: any) => {
        return data.value ? 'Y' : '-';
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    배송구분: {
      // 배송구분
      header: 'CLAIM_COLUMNS_SHIPPING_AREA_TYPE',
      name: 'shippingAreaType',
      minWidth: 101,
      align: 'center',
      formatter: ({row}) => {
        return row.partnerNo === row.deliveryPartnerNo ? window.$t('CLAIM_COLUMNS_PARTNER_SHIPPING') : window.$t('CLAIM_COLUMNS_MALL_SHIPPING');
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    업무메세지: {
      header: 'CLAIM_COLUMNS_TASK_MESSAGE',
      name: 'hasTaskMessage',
      minWidth: 81,
      align: 'center',
      formatter: function(data: any): any {
        const {taskMessageCnt, taskMessageProcessCnt} = data.row;
        // taskMessageCnt > 0 이면 처리중으로 표시
        if (taskMessageCnt === 0) {
          return '';
        }

        if (taskMessageProcessCnt > 0) {
          return `<a href="/order/detail?orderNo=${data.row.orderNo}" target="_blank" class="taskMessageBtn taskMseeageBtnImg" style="width: 18px; height: 18px; margin-top: 2px; display: inline-block;"></a>`;
        }

        return `<a href="/order/detail?orderNo=${data.row.orderNo}" target="_blank" class="taskMessageBtn taskMseeageCompleteBtnImg" style="width: 18px; height: 18px; margin-top: 2px; display: inline-block;"></a>`;
      },
      copyOptions: {
        useFormattedValue: true,
        customValue: (data: any): any => {
          if (data === true) {
            return 'Y';
          } else {
            return '';
          }
        }
      }
    },
    회원그룹: {
      header: 'CLAIM_COLUMNS_MEMBER_GROUP_INFO_JSON',
      name: 'memberGroupInfoJson',
      minWidth: 61,
      align: 'center',
      formatter: (data: any) => {
        if (data.value == null || data.value === '' || data.value === '[]') {
          return '-';
        }

        const memberGroupInfo = JSON.parse(data.value);
        if (memberGroupInfo === null || memberGroupInfo.length <= 0) {
          return '-';
        } else if (memberGroupInfo.length == 1) {
          return memberGroupInfo[0].memberGroupName;
        }

        return `<a href="javascript:;" class="member-group-name-grid" data-json='${JSON.stringify(memberGroupInfo).replace(/"/g, '\\"')}'>${memberGroupInfo[0].memberGroupName}</a>`;
      },
      copyOptions: {
        useFormattedValue: true,
        customValue: function(data: any): any {
          if (data == null || data === '' || data === '[]') {
            return '-';
          }

          const memberGroupInfo = JSON.parse(data);
          if (memberGroupInfo === null || memberGroupInfo.length <= 0) {
            return '-';
          } else if (memberGroupInfo.length == 1) {
            return memberGroupInfo[0].memberGroupName;
          }

          return memberGroupInfo[0].memberGroupName;
        }
      }
    },
    주문번호: {
      header: 'CLAIM_COLUMNS_ORDER_NO',
      name: 'orderNo',
      minWidth: 161,
      align: 'center',
      formatter: (data: any) => {
        return `<a href="/order/detail?orderNo=${data.row.orderNo}" onMouseOver="this.style.cursor='pointer'" target="_blank">${data.value}</a>`;
      }
    },
    주문자명: {
      header: 'ORDER_LIST_GRIDS_HEADER_ORDER_NAME',
      align: 'center',
      minWidth: 80,
      name: 'ordererName',
      formatter: function(data: any): any {
        const memberNo = data.row.memberNo;
        if (memberNo > 0) {
          return `<a href="javascript:;" class="ordererPopup" data-memberno="${memberNo}" onclick="window.open('/member/popup/crm/${memberNo}', '상세보기', '${centerWinOptions(1024, 982)}')">${
            data.value
          }</a>`;
        }
        return data.value;
      },
      copyOptions: {
        useFormattedValue: false
      }
    },
    '주문자 연락처': {
      header: 'CLAIM_COLUMNS_ORDERER_CONTACT',
      name: 'ordererContact',
      minWidth: 101,
      align: 'center'
    },
    회원번호: {
      header: 'CLAIM_COLUMNS_MEMBER_NO',
      name: 'memberNo',
      minWidth: 81,
      align: 'center'
    },
    수령자명: {
      header: 'CLAIM_COLUMNS_RECEIVER_NAME',
      name: 'receiverName',
      minWidth: 71,
      align: 'center'
    },
    수령자연락처: {
      header: 'CLAIM_COLUMNS_RECEIVER_CONTACT',
      name: 'receiverContact',
      minWidth: 101,
      align: 'center'
    },
    상품번호: {
      header: 'CLAIM_COLUMNS_MALL_PRODUCT_NO',
      name: 'mallProductNo',
      minWidth: 81,
      align: 'center'
    },
    상품관리코드: {
      header: 'CLAIM_COLUMNS_PRODUCT_MANAGEMENT_CD',
      name: 'productManagementCd',
      minWidth: 81,
      align: 'center'
    },
    상품명: {
      header: 'CLAIM_COLUMNS_PRODUCT_NAME',
      name: 'productName',
      minWidth: 201,
      align: 'left',
      formatter: (data: any) => {
        if (data.row.setOptionsJson) {
          return `<span class="tag pink">${window.$t('ORDER_LIST_GRIDS_PRODUCT_NAME_TAG')}</span> ${data.value}`;
        }
        if (data.row?.isFreeGift) {
          const button = data.row.freeGiftConditionBrokenType === 'CLAIM_DONE' ? '<button class="alert-exclamation"></button>' : '';
          return `<span class="green-badge">사은품</span>${ button }${data.value}`;
        }
        return data.value;
      }
    },
    옵션관리코드: {
      header: 'CLAIM_COLUMNS_OPTION_MANAGEMENT_CD',
      name: 'optionManagementCd',
      minWidth: 81,
      align: 'left'
    },
    '옵션명:옵션값': {
      header: 'CLAIM_COLUMNS_DISPLAY_OPTION_NAME',
      name: 'displayOptionName',
      minWidth: 151,
      align: 'left',
      formatter: ({row}) => {
        return row.optionNameForDisplay;
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    취소수량: {
      ...this.columnFormat.claimCnt,
      header: 'CLAIM_COLUMNS_CNT_CANCEL'
    },
    교환수량: {
      ...this.columnFormat.claimCnt,
      header: 'CLAIM_COLUMNS_CNT_EXCHANGE'
    },
    반품수량: {
      ...this.columnFormat.claimCnt,
      header: 'CLAIM_COLUMNS_CNT_RETURN'
    },
    상품수: {
      ...this.columnFormat.claimCnt,
      header: 'CLAIM_COLUMNS_CNT_PRODUCT'
    },
    수거지주소: {
      header: 'CLAIM_COMMON_RETURN_ADDRESS',
      name: 'address',
      minWidth: 302,
      align: 'left',
      formatter: ({row}) => {
        return `${row.zipCd ? `(${row.zipCd})` : ''} ${row.address} ${row.detailAddress}`;
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    수거시참고사항: {
      header: 'CLAIM_COMMON_RETURN_MEMO',
      name: 'note',
      minWidth: 121,
      align: 'left'
    },
    '판매가(할인적용가)': {
      header: 'ORDER_LIST_GRIDS_HEADER_IMMEDIATE_DISCOUNT_PRICE',
      name: 'immediateDiscountedPrice',
      align: 'right',
      minWidth: 80,
      formatter: (data: any): any => {
        const price = data.row.salePrice + data.row.addPrice - data.row.immediateDiscountAmt;
        return price.toLocaleString();
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    취소금액: {
      header: 'ORDER_LIST_GRIDS_HEADER_CLAIM_AMT',
      name: 'claimAmt',
      align: 'right',
      minWidth: 80,
      formatter: (data: any): any => {
        return (data.value * -1).toLocaleString();
      }
    },
    교환금액: {
      header: 'ORDER_LIST_GRIDS_HEADER_CLAIM_AMT_FOUR',
      name: 'claimAmt',
      align: 'right',
      minWidth: 80,
      formatter: (data: any): any => {
        return (data.value * -1).toLocaleString();
      }
    },
    반품금액: {
      header: 'ORDER_LIST_GRIDS_HEADER_CLAIM_AMT_THREE',
      name: 'claimAmt',
      align: 'right',
      minWidth: 80,
      formatter: (data: any): any => {
        return (data.value * -1).toLocaleString();
      }
    },
    파트너사: {
      header: 'ORDER_LIST_GRIDS_HEADER_PARTER_NO',
      name: 'partnerNo',
      align: 'center',
      minWidth: 100,
      formatter: function(data: any): any {
        return data.row.partnerName;
      }
    },
    환불금액: {
      header: 'ORDER_LIST_GRIDS_HEADER_REFUND_TMDT',
      name: 'claimAmt',
      align: 'right',
      minWidth: 80,
      formatter: (data: any): any => {
        return Number(data.value).toLocaleString();
      }
    },
    환불수단: {
      header: 'ORDER_LIST_GRIDS_HEADER_REFUND_PAY_TYPE',
      align: 'center',
      minWidth: 100,
      name: 'refundType',
      formatter: (data: any): any => {
        if (!data.value) {
          return '-';
        }

        if (data.value === RefundType.PG) {
          return `${data.row.displayRefundType.label}[${data.row.refundPayTypeLabel}]`;
        }

        return window.$t(`CLAIM_COMMON_${data.value}_REFUND`);
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    '정기결제(배송) 신청 번호': {
      header: 'ORDER_LIST_GRIDS_HEADER_RECURRING_PAYMENT_NO',
      align: 'center',
      minWidth: 150,
      name: 'recurringPaymentNo',
      formatter: ({ value }: { value?: string }): string => value ?? '-',
    },
    주문상품옵션번호: {
      header: 'ORDER_LIST_GRIDS_ORDER_PRODUCT_OPTION_NO',
      minWidth: 100,
      name: 'orderOptionNo',
      align: 'center',
      visible: false,
      copyOptions: {
        useFormattedValue: true,
      },
    },
  };

  private claimManagementBtnMaker(claimStatusType: ClaimStatusType, claimNo: string, orderOptionNo: string): string {
    let option: OptionForOpeningWindow = {
      url: `/claim/viewPopup?orderProductOptionNo=${orderOptionNo}&isResult=true&claimNo=${claimNo}&callback=reSearchClaim`,
      label: window.$t('CLAIM_COLUMNS_SHOW_DETAIL'),
      widthOfWindow: 1024,
      heightOfWindow: 982,
    };
    const optionForCollectReturnPopup: OptionForOpeningWindow = {
      url: `/claim/collectReturnPopup?claimNo=${claimNo}&callback=reSearchClaim`,
      label: window.$t('CLAIM_COLUMNS_PROC_COLLECT_COMPLETE'),
      widthOfWindow: 800,
      heightOfWindow: 400,
    }

    switch (claimStatusType) {
      case 'CANCEL_REQUEST':
        option.label = window.$t('CLAIM_COLUMNS_PROC_CANCEL');
        break;
      case 'EXCHANGE_PROC_BEFORE_RECEIVE':
        option = optionForCollectReturnPopup;
        break;
      case 'EXCHANGE_REQUEST':
        option.label = window.$t('CLAIM_COLUMNS_PROC_EXCHANGE');
        break;
      case 'RETURN_PROC_BEFORE_RECEIVE':
        option = optionForCollectReturnPopup
        break;
      case 'RETURN_REQUEST':
        option.label = window.$t('CLAIM_COLUMNS_PROC_RETURN');
        break;
    }

    const btn = `
              <button
                type="button"
                style="height:20px;"
                onclick="window.open(
                    '${option.url}',
                    '${option.label}',
                    '${centerWinOptions(option.widthOfWindow, option.heightOfWindow)}'
                  )"
              >
                ${option.label}
              </button>
            `;
    return btn;
  }

  // TODO: 이런 형태와 유사한 디자인 패턴이 있는지 서칭
  protected getClaimColumns(claimType: ClaimType) {
    const columns = {
      CANCEL: [
        '취소신청일시',
        '취소완료일시',
        '취소클레임처리',
        '송장번호',
        '클레임상태',
        '클레임번호',
        '쇼핑몰구분',
        '주문구분',
        '예약주문',
        '결제수단',
        '배송보류',
        '배송구분',
        '업무메세지',
        '회원그룹',
        '주문번호',
        '주문자명',
        '주문자 연락처',
        '회원번호',
        '수령자명',
        '수령자연락처',
        '상품번호',
        '상품관리코드',
        '상품명',
        '옵션관리코드',
        '옵션명:옵션값',
        '취소수량',
        '판매가(할인적용가)',
        '취소금액',
        '파트너사',
        '주문상품옵션번호',
        '정기결제(배송) 신청 번호',
      ],
      EXCHANGE: [
        '교환신청일시',
        '교환완료일시',
        '교환클레임처리',
        '송장번호',
        '반품송장번호',
        '클레임상태',
        '클레임번호',
        '쇼핑몰구분',
        '주문구분',
        '예약주문',
        '배송보류',
        '결제수단',
        '배송구분',
        '업무메세지',
        '회원그룹',
        '주문번호',
        '주문자명',
        '주문자 연락처',
        '회원번호',
        '수령자명',
        '수령자연락처',
        '상품번호',
        '상품관리코드',
        '상품명',
        '옵션관리코드',
        '옵션명:옵션값',
        '교환수량',
        '판매가(할인적용가)',
        '교환금액',
        '파트너사',
        '주문상품옵션번호',
        '정기결제(배송) 신청 번호',
      ],
      RETURN: [
        '반품신청일시',
        '반품완료일시',
        '반품수거방법',
        '반품클레임처리',
        '송장번호',
        '반품송장번호',
        '클레임상태',
        '클레임번호',
        '쇼핑몰구분',
        '주문구분',
        '예약주문',
        '결제수단',
        '배송구분',
        '업무메세지',
        '회원그룹',
        '주문번호',
        '주문자명',
        '주문자 연락처',
        '회원번호',
        '수령자명',
        '수령자연락처',
        '상품번호',
        '상품관리코드',
        '상품명',
        '옵션관리코드',
        '옵션명:옵션값',
        '반품수량',
        '판매가(할인적용가)',
        '반품금액',
        '파트너사',
        '주문상품옵션번호',
        '정기결제(배송) 신청 번호',
      ],
      REFUND: [
        '환불신청일시',
        '환불완료일시',
        '클레임상태',
        '클레임번호',
        '쇼핑몰구분',
        '주문구분',
        '예약주문',
        '결제수단',
        '업무메세지',
        '회원그룹',
        '주문번호',
        '주문자명',
        '주문자 연락처',
        '회원번호',
        '수령자명',
        '수령자연락처',
        '상품수',
        '환불금액',
        '환불수단',
        '주문상품옵션번호',
        '정기결제(배송) 신청 번호',
      ]
    };

    return columns[claimType].map(columnName => this.claimListColumns[columnName]);
  }

  protected async getExcelDownInfo(claimType: ClaimType, gridName: GridNameType) {
    // TODO: 원래라면 ItemTable에서 이미 getGridLayouts 한번 호출 된 상태. 차후 getGridLayouts이후 excelInfo가 set이 담보되도록 ItemTable 리팩토링 필요. 사이드이펙트 우려
    const {data: gridColumns} = await this.$api.getGridLayouts({params: {gridName: gridName as any}});

    const columnNames = gridColumns.map(columnsOrder => columnsOrder.columnName);

    // 모든 CANCEL, EXCHANGE, RETURN, REFUND의 모든 excelDownInfo columns
    const excelDownInfoColumns = {
      claimYmdt: `CLAIM_COLUMNS_${claimType}_YMDT`,
      claimCompleteYmdt: `CLAIM_COLUMNS_${claimType}_COMPLETE_YMDT`,
      completeYmdt: `CLAIM_COLUMNS_${claimType}_COMPLETE_YMDT`,
      returnWayType: 'CLAIM_COLUMNS_RETURN_WAY_TYPE',
      claimStatusType: 'CLAIM_COLUMNS_CLAIM_STATUS_TYPE',
      invoiceNo: 'CLAIM_COMMON_INVOICE_NO',
      returnInvoiceNo: 'CLAIM_COMMON_RETURN_INVOICE_NO',
      claimNo: 'CLAIM_COLUMNS_CLAIM_NO',
      mallName: 'CLAIM_COLUMNS_MALL_NAME',
      orderRegisterType: 'CLAIM_COLUMNS_ORDER_REGISTER_TYPE',
      reserved: 'CLAIM_COLUMNS_RESERVED',
      payType: 'CLAIM_COLUMNS_PAYTYPE',
      holdProcess: 'CLAIM_COLUMNS_HOLD_PROCESS',
      shippingAreaType: 'CLAIM_COLUMNS_SHIPPING_AREA_TYPE',
      hasTaskMessage: 'CLAIM_COLUMNS_TASK_MESSAGE',
      memberGroupInfoJson: 'CLAIM_COLUMNS_MEMBER_GROUP_INFO_JSON',
      orderNo: 'CLAIM_COLUMNS_ORDER_NO',
      ordererName: 'CLAIM_COLUMNS_ORDERER_NAME',
      ordererContact: 'CLAIM_COLUMNS_ORDERER_CONTACT',
      memberNo: 'CLAIM_COLUMNS_MEMBER_NO',
      receiverName: 'CLAIM_COLUMNS_RECEIVER_NAME',
      receiverContact: 'CLAIM_COLUMNS_RECEIVER_CONTACT',
      mallProductNo: 'CLAIM_COLUMNS_MALL_PRODUCT_NO',
      productManagementCd: 'CLAIM_COLUMNS_PRODUCT_MANAGEMENT_CD',
      productName: 'CLAIM_COLUMNS_PRODUCT_NAME',
      optionManagementCd: 'CLAIM_COLUMNS_OPTION_MANAGEMENT_CD',
      displayOptionName: 'CLAIM_COLUMNS_DISPLAY_OPTION_NAME',
      claimCnt: `CLAIM_COLUMNS_CNT_${claimType}`,
      claimAmt: `CLAIM_COLUMNS_CLAIM_AMT_${claimType}`,
      immediateDiscountedPrice: 'ORDER_LIST_GRIDS_HEADER_IMMEDIATE_DISCOUNT_PRICE',
      partnerNo: 'ORDER_LIST_GRIDS_HEADER_PARTER_NO',
      address: 'CLAIM_COMMON_RETURN_ADDRESS',
      note: 'CLAIM_COMMON_RETURN_MEMO'
    };

    // gridProps의 column 이름과 excel 컬럼 이름을 매칭시켜 excelDownInfo의 columns를 만든다.
    const columns = columnNames.reduce((columns, columnName) => {
      if (!excelDownInfoColumns[columnName]) {
        return columns;
      }

      return {...columns, [columnName]: excelDownInfoColumns[columnName]};
    }, {});

    const excelDownInfo = {
      fileName: `order_${claimType.toLowerCase()}ed_`,
      nameDateFormat: 'YYYYMMDD_HHmmss',
      columns,
      formatters: {
        claimStatusType: row => {
          return this.$t(`CLAIM_COMMON_${row.value}`);
        },
        holdProcess: (row: any) => {
          return row.value ? 'Y' : '-';
        },
        invoiceNo: row => {
          return row.value ? row.value : '-';
        },
        returnInvoiceNo: row => {
          return row.value ? row.value : '-';
        },
        claimCompleteYmdt: row => {
          return row.value ? row.value : '-';
        },
        returnWayType: (row: any) => {
          return row.value ? this.$t(`ORDER_ORDER_CONTENT_TOP_RETURN_WAY_TYPE_${row.value}`) : '-';
        },
        memberGroupInfoJson: (row: any) => {
          if (row.value == null || row.value === '' || row.value === '[]') {
            return '-';
          }
          const memberGroupInfo = JSON.parse(row.value);

          if (memberGroupInfo.length <= 0) {
            return '-';
          }

          return memberGroupInfo[0].memberGroupName;
        },
        reserved: (row: any) => {
          return row.value ? 'Y' : '-';
        },
        orderRegisterType: row => {
          return this.$t(`CLAIM_COLUMNS_ORDER_REGISTER_TYPE_${row.value}`);
        },
        payType: row => {
          return row.row.payTypeLabel;
        },
        hasTaskMessage: (row: any) => {
          if (row.value) {
            return this.$t('CLAIM_COMMON_PROCESSING');
          } else {
            return '';
          }
        },
        displayOptionName: ({row}) => {
          return `${row.optionName}:${row.optionValue}`;
        },
        shippingAreaType: ({row}) => {
          return row.partnerNo === row.deliveryPartnerNo ? window.$t('CLAIM_COLUMNS_PARTNER_SHIPPING') : window.$t('CLAIM_COLUMNS_MALL_SHIPPING');
        },
        immediateDiscountedPrice: (data: any): any => {
          const price = data.row.salePrice + data.row.addPrice - data.row.immediateDiscountAmt;
          return price;
        },
        claimAmt: (data: any): any => {
          return data.value * -1;
        },
        partnerNo: (data: any): any => {
          return data.row.partnerName;
        }
      }
    };

    return excelDownInfo;
  }
}
